import { render } from "./CustomBlock.vue?vue&type=template&id=3e87d5da"
import script from "./CustomBlock.vue?vue&type=script&lang=js"
export * from "./CustomBlock.vue?vue&type=script&lang=js"
script.render = render

export default script